<div i18n="@@SnackbarHottestEventsWillAppear" *ngIf="data === 'confirmFollow'">
  From now on, the hottest events will appear in main page
</div>
